﻿const productGroupUrl = '/ppapi/ProductGroup';

export async function getProductGroup(group, id) {
    if (typeof id === 'number' && id > 0) {
        group.id = id;
    }

    const response = await fetch(`${productGroupUrl}/${group.id}`, {
        method: 'GET',
        cache: 'no-cache'
    });
    const result = await response.json();

    if (Object.keys(result).length > 0) {
        if (typeof result.Name !== "undefined") {
            group.name = result.Name;
        }

        if (typeof result.OrderNumber !== "undefined") {
            group.orderNumber = result.OrderNumber;
        }
    }

    return group;
}

export class ProductGroup {
    constructor({
        id,
        name,
        orderNumber
    }) {
        this.id = id;
        this.name = name;
        this.orderNumber = orderNumber;
        this.products = [];
    }
}

export async function getProductGroups({
    arr,
    page,
    count,
    type,
    groupId,
    token
}) {

    if (typeof arr == 'undefined') {
        arr = [];
    }
    //arr = [];

    
    if (typeof page != 'number' && page <= 0) {
        page = 1;
    }

    if (typeof type != 'string' && type == '') {
        type = 'short';
    }

    let url = `${productGroupUrl}?page=${page}&count=${count}&type=${type}`;

    if (!!token) {
        url = `${url}&authToken=${token}`;
    }

    const response = await fetch(url, {
        method: 'GET',
        cache: 'no-cache'
    });
    const results = await response.json();

    if (results.length > 0) {
        results.forEach(item => {
            const group = new ProductGroup({
                id: item.ID,
                orderNumber: item.OrderNumber,
                name: item.Name
            });

            arr.push(group);
        });
    }

    return (results.length > 0);
}

export class ProductGroups extends Array {
    constructor(...args) {
        super(...args);
    }

    static get [Symbol.species]() {
        return Array;
    }
}